import { Pipe, PipeTransform } from '@angular/core';
import { StringUtil } from 'src/app/util/string-util';
@Pipe({ name: 'phoneObfuscate' })
export class PhoneObfuscatePipe implements PipeTransform {
  transform(phone: string): string {
    if (!phone) return '-';
    return StringUtil.obfuscateTelephone(phone);
  }
}
